// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"kq-z","breadcrumbForward":"lq-z","breadcrumbBack":"mq-z","selected":"nq-z"};